import { environment } from 'src/environments/environment';

export function getBlobUrl(container: string, path?: string | null): string {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('data:')) return path;
  return `${environment.filesDownloadURL}${container}/${path}`;
}
